export const RISK = {
  emergencial: { label: "Emergencial", color: "#DC2626", bg: "#FEF2F2", ring: "border-red-600" },
  alta: { label: "Alta prioridade", color: "#EA580C", bg: "#FFF7ED", ring: "border-orange-600" },
  moderada: { label: "Moderada", color: "#B45309", bg: "#FEFCE8", ring: "border-yellow-600" },
  programado: { label: "Programado", color: "#16A34A", bg: "#F0FDF4", ring: "border-green-600" },
};

// Legado — mantido para retrocompatibilidade das telas antigas.
export const STATUS_LABEL = {
  triagem: "Aguardando triagem",
  analise: "Em análise",
  consultor_designado: "Consultor designado",
  clinica_selecionada: "Clínica selecionada",
  reserva_confirmada: "Reserva confirmada",
  internado: "Internado",
  concluido: "Caso concluído",
};

// RAF Direct — 12 status canônicos oficiais.
export const OFFICIAL_STATUS_LABEL = {
  CADASTRO_ACOLHIMENTO:            "Cadastro e acolhimento",
  TRIAGEM_EM_ANDAMENTO:            "Triagem Inteligente RAF em andamento",
  TRIAGEM_CONCLUIDA:               "Triagem Inteligente RAF concluída",
  ANALISE_RAF:                     "Análise da Equipe RAF",
  PLANO_DIRECAO_FAMILIAR:          "Plano de Direção Familiar",
  COMPATIBILIDADE_DIRECIONAMENTO:  "Compatibilidade e direcionamento",
  UNIDADE_PARCEIRA_INDICADA:       "Unidade Parceira indicada",
  RESERVA:                         "Reserva",
  AGENDAMENTO:                     "Agendamento",
  INTERNADA:                       "Internação realizada",
  NAO_INTERNADA:                   "Internação não realizada",
  ATENDIMENTO_CONCLUIDO:           "Conclusão do atendimento RAF",
};

export const OFFICIAL_STATUS_SEQUENCE = [
  "CADASTRO_ACOLHIMENTO",
  "TRIAGEM_EM_ANDAMENTO",
  "TRIAGEM_CONCLUIDA",
  "ANALISE_RAF",
  "PLANO_DIRECAO_FAMILIAR",
  "COMPATIBILIDADE_DIRECIONAMENTO",
  "UNIDADE_PARCEIRA_INDICADA",
  "RESERVA",
  "AGENDAMENTO",
  "INTERNADA",
  "ATENDIMENTO_CONCLUIDO",
];

// Progresso oficial por estado (espelha /app/backend/state_machine.py::PROGRESS_BY_STATUS).
export const OFFICIAL_STATUS_PROGRESS = {
  CADASTRO_ACOLHIMENTO: 5,
  TRIAGEM_EM_ANDAMENTO: 15,
  TRIAGEM_CONCLUIDA: 28,
  ANALISE_RAF: 40,
  PLANO_DIRECAO_FAMILIAR: 52,
  COMPATIBILIDADE_DIRECIONAMENTO: 63,
  UNIDADE_PARCEIRA_INDICADA: 72,
  RESERVA: 82,
  AGENDAMENTO: 90,
  INTERNADA: 96,
  NAO_INTERNADA: 96,
  ATENDIMENTO_CONCLUIDO: 100,
};

// SLA operacional RAF Direct (horas máximas por etapa). Espelha
// /app/backend/state_machine.py::SLA_HOURS_BY_STATUS.
export const OFFICIAL_STATUS_SLA_HOURS = {
  CADASTRO_ACOLHIMENTO: 2,
  TRIAGEM_EM_ANDAMENTO: 4,
  TRIAGEM_CONCLUIDA: 2,
  ANALISE_RAF: 8,
  PLANO_DIRECAO_FAMILIAR: 12,
  COMPATIBILIDADE_DIRECIONAMENTO: 6,
  UNIDADE_PARCEIRA_INDICADA: 24,
  RESERVA: 48,
  AGENDAMENTO: 72,
  INTERNADA: null,
  NAO_INTERNADA: null,
  ATENDIMENTO_CONCLUIDO: null,
};

/** Retorna { hours, meta, ratio, level: 'green'|'yellow'|'red'|'none' } */
export function computeSla(caseObj) {
  const status = caseObj?.official_status;
  const meta = OFFICIAL_STATUS_SLA_HOURS[status];
  const since = caseObj?.official_status_since || caseObj?.updated_at || caseObj?.created_at;
  if (!since) return { level: "none" };
  const hours = (Date.now() - new Date(since).getTime()) / 3_600_000;
  if (meta == null) return { hours, meta: null, level: "none" };
  const ratio = hours / meta;
  let level = "green";
  if (ratio > 1) level = "red";
  else if (ratio > 0.5) level = "yellow";
  return { hours, meta, ratio, level };
}

// Rótulo público sanitizado para uma clínica quando exibida à Família.
// A identidade comercial fica reservada; a Família vê apenas "Unidade Parceira RAF 0047 — Cidade/UF".
export const partnerUnitLabel = (clinic) => {
  if (!clinic) return "Unidade Parceira RAF";
  const shortId = String(clinic.id || "").replace(/-/g, "").slice(0, 4).toUpperCase() || "0000";
  const loc = [clinic.city, clinic.state].filter(Boolean).join("/");
  return `Unidade Parceira RAF ${shortId}${loc ? " — " + loc : ""}`;
};
